<template>
    <div class="person">
        <div v-if="participant.image" class="person__media">
            <div class="person__intrinsic-ratio">
                <img
                    class="person__image"
                    :src="imageUrl(participant, {width: 250, height: 250})"
                    width="150"
                    height="150"
                    :alt="participant.image.alt"
                />
            </div>
        </div>

        <div class="person__details" :class="{'person__details--full': !participant.image}">
            <h3 class="person__name">{{ participant.firstName }}, {{ participant.lastName }}</h3>

            <p v-if="participant.role" class="person__role">{{ participant.attributes.custom.role }}</p>
            <p v-if="participant.position" class="person__position">{{ participant.position }}</p>
        </div>
    </div>
</template>

<script>
import {inject} from 'vue';

export default {
  name: 'OrchestraItem',
  props: {
    participant: {
      type: Object,
      required: true,
    }
  },
  setup(props) {
    const imageUrl = inject('imageUrl');

    return {
        imageUrl,
    }
  }
}
</script>